import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { ClimateProvider } from "../../context/ClimateContext";

export const Climate = () => {
  return (
    <ClimateProvider>
      <Overview />
    </ClimateProvider>
  );
};

export const AddClimate = () => {
  return (
    <ClimateProvider>
      <Add />
    </ClimateProvider>
  );
};

export const EditClimate = () => {
  return (
    <ClimateProvider>
      <Edit />
    </ClimateProvider>
  );
};
